import { useQuery, gql } from "@apollo/client"
import { CATEGORIES_FIELDS } from "../knowledge"

const TEMPLATE_CATEGORIES_QUERY = gql`query {
  templateCategories {
    ${CATEGORIES_FIELDS}
  } 
}`

const useQueryTemplateCategories = () =>
  useQuery(TEMPLATE_CATEGORIES_QUERY, {
    fetchPolicy: "cache-and-network",
  })

export { useQueryTemplateCategories }
